export default "__VITE_ASSET__882f3a04__"